/**
 * 推广管理
 */
import { PageContext, uuid } from '@zto/zpage'
import { addEditDialog } from './_dialogs'
import { UI_PAGE_EVENTS } from '@zto/zpage-ui-element'
import { commonOptions } from '@/config/options'
import { PromotionTypeName, ListingStatusName, ScopeTypeName, ListingStatus } from '@/config/enums'
import dayjs from 'dayjs'

export default {
  body: {
    type: 'crud',
    actions: {
      query: {
        api: '/cabinet/admin/mkt/AdminMktShopConfigQueryController/page'
      },
      add: {
        label: '手动新增',
        ...addEditDialog('add')
      },
      import:{
        label: '导入新增',
        api: '/cabinet/admin/mkt/AdminMktShopConfigCommandController/import',
        apiParams: () => ({ batchNum: uuid() }),
        template: 'import_shop_config',
        dataProp: 'list',
        maxCount: 1000,
        // transformMethod: (data: any) => {
        //   console.info('🚀 ~ file:index method:transformMethod line:30 ----- data', data)
        //   return (data || []).map((item: any) => {
        //     return {
        //       ...item,
        //       mktStaySeconds: item.mktStaySeconds || 0
        //     }
        //   })
        // },
        clearBeforeShow: true // 显示弹窗前清除文件
      },
      edit: {
        label: '编辑',
        ...addEditDialog('edit')
      },
      delete: {
        label: '删除',
        api: '/cabinet/admin/mkt/AdminMktShopConfigCommandController/delete',
        payload: {
          shopCode: '${data.row.shopCode}'
        },
        message: '是否确认删除这条配置?'
      }
    },
    searchOn: [UI_PAGE_EVENTS.ACTIVATED],
    search: {
      items: [
        {
          type: 'input',
          prop: 'shopCode',
          label: '门店编号',
          span: 8
        }
      ],
      afterSearch: ({ app, searchParams }: any) => {
        // if (searchParams.supplierCode) {
        //   searchParams.isCheck = true
        // } else {
        //   searchParams.isCheck = false
        // }
        // app.setPageSearchData('isCheck', searchParams.isCheck)
      }
    },
    toolbar: {
      noExport: true,
      items: [
        { action: 'add' },
        { action: 'import' }
      ]
    },
    table: {
      operation: {
        width: 150,
        items: [
          {
            action: 'edit',
            // visibleOn: `this.data.row.status === '${ListingStatus.OFF}'`
          },
          {
            action: 'delete',
            // visibleOn: `this.data.row.status === '${ListingStatus.OFF}'`
          }
        ]
      },
      columns: [
        {
          label: '门店编号',
          prop: 'shopCode',
          minWidth: 180
        },
        {
          label: '营销中间页停留时长（秒）',
          minWidth: 150,
          formatter: (row: any) => {
            return row.mktStaySeconds || 0
          }
        },
        {
          label: '创建时间',
          minWidth: 150,
          formatter: (row: any) => {
            return row.gmtCreate ? dayjs(row.gmtCreate).format('YYYY-MM-DD HH:mm:ss') : '--'
          }
        },
        {
          label: '更新时间',
          minWidth: 150,
          formatter: (row: any) => {
            return row.gmtModified ? dayjs(row.gmtModified).format('YYYY-MM-DD HH:mm:ss') : '--'
          }
        }
      ]
    }
  }
}
